import { drawerBodyStyle, drawerCloseStyles, drawerUtilitiesStyles, drawerContainerStyle } from './styles';
import React from 'react';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { ISmartProps } from './types';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import { CloseIconComponent } from '../../Utilities/utils/Theming';
import { Button } from '../Button';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps, theme: typeof Theme, css: any, onDettach: any, dettached: boolean) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const closeOffset = props.offset
		? 'calc(var(--epods--drawer-close-spacing-top) + ' + props.offset + ' + 10px)'
		: 'calc(var(--epods--drawer-close-spacing-top) + 10px)';
	return {
		Close: {
			component: ({ onClick }: any) => (
				<div style={{ width: '35px' }}>
					<div style={{ position: 'relative', zIndex: '2' }}> {/* drawerUtilitiesStyles(props) */}
						<CloseIconComponent onClick={onClick} style={{ position: 'absolute', marginLeft: props.dettachable ? '5px' : '-5px', ...drawerCloseStyles(props), right: '5px' }} />
					</div>
					<div style={{ position: 'relative', zIndex: '1' }}>
						{props.dettachable && <Button
							style={{ position: 'absolute', ...drawerCloseStyles(props) as any, top: closeOffset, right: '3px' }}
							theme="toggle-phantom"
							isSelected={dettached}
							onClick={onDettach}
							iconBefore="pin"
						/>}
					</div>
				</div>
			),
		},
		DrawerBody: {
			style: ({ $theme }: any) => {

				return {
					...drawerBodyStyle(props, $theme),
				};
			},
			props: {
				'data-epo': `epo-drawer-${meta.version}`,
				part: `epo-drawer-${meta.version}`,
			},
		},
		Backdrop: {
			style: () => {
				const _show = props.showBackdrop === false ? { display: 'none' } : {}
				return {
					..._show
				}
			}
		},
		DrawerContainer: {
			style: ({ $theme }: any) => {
				let _shadowMap: any = {
					'left': 'var(--epods--box-shadow-forth-right)',
					'right': 'var(--epods--box-shadow-forth-left)',
					'top': 'var(--epods--box-shadow-forth-bottom)',
					'bottom': 'var(--epods--box-shadow-forth-top)',
				}
				let _shadow = 'var(--epods--box-shadow-forth-left)';
				_shadow = props.anchor ? _shadowMap[props.anchor] : _shadow;

				let _dettached = dettached
					? {
						height: '80vh',
						width: '80vw',
						left: '10vw',
						top: '10vh',
					}
					: {}
				return {
					...drawerContainerStyle(_shadow, $theme),
					..._dettached,
				}
			},
		},
		Root: {
			style: {
				zIndex: props.zIndex || ('var(--epods--zindex-modal-backdrop)' as any),
				width: props.showBackdrop ? 'auto' : 'fit-content'
			},
			props: {
				'data-epo': `epo-drawer-${meta.version}`,
				part: `epo-drawer-${meta.version}`,
				id: props.id,
				className: props.className,
				...HTMLAttrs.ariaProps,
				...HTMLAttrs.dataProps,
				...getBaseCustomProps(props),
			},
		},
	};
};
